import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@common/modules/base/base.component';
import { CustomValidators } from '@shared/validators';
import { MinhaContaController } from '@modules/configuracoes/controllers';
import { AuthService } from '@infra/auth/auth.service';

@Component({
  selector: 'app-minha-conta',
  templateUrl: './minha-conta.component.html',
  styleUrls: ['./minha-conta.component.scss'],
})
export class MinhaContaComponent extends BaseComponent {
  public form: FormGroup;
  public passwordVisible = false;
  public isSubmitting = false;
  public isSuccess = false;
  public isError = false;
  public errorMessage = '';

  constructor(
    public minhaContaController: MinhaContaController,
    public authService: AuthService,
    private formBuilder: FormBuilder,
  ) {
    super('Minha conta - Portal do Cliente');
    this.form = this.createForm();
  }

  private createForm() {
    return this.formBuilder.group(
      {
        nome: [{ value: this.authService.usuario?.nomeFantasia, disabled: true }],
        email: [{ value: this.authService.usuario?.email, disabled: true }],
        telefone: [{ value: this.authService.usuario?.telefone, disabled: true }],
        senhaAtual: ['', [Validators.required, Validators.minLength(4)]],
        senha: ['', [Validators.required, Validators.minLength(4)]],
        confirmarSenha: ['', [Validators.required, Validators.minLength(4)]],
      },
      { validators: CustomValidators.confirmarSenha },
    );
  }

  public submit(): void {
    if (this.form.valid) {
      this.isSubmitting = true;
      this.isSuccess = false;
      this.isError = false;
      this.errorMessage = '';

      const data = {
        senha: this.form.value.senha || undefined,
        senhaAtual: this.form.value.senhaAtual || undefined,
        nome: this.form.value.nome || undefined,
        email: this.form.value.email || undefined,
        telefone: this.form.value.telefone || undefined,
      };

      this.minhaContaController.atualizarUsuario(data).subscribe({
        next: () => {
          this.isSubmitting = false;
          this.isSuccess = true;

          this.form.reset({
            nome: this.authService.usuario?.nomeFantasia,
            email: this.authService.usuario?.email,
            telefone: this.authService.usuario?.telefone,
          });
        },
        error: (errors) => {
          this.isSubmitting = false;
          this.isError = true;
          this.errorMessage = errors.message[0];
        },
      });
    }
  }
}
